<template>
  <div style="background: #f5f3f3;">
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="shop-more-body">
      <div class="shop-title">
        <h2 class="shop-title-h2">所有{{tabTitle}}商品</h2>
        <span>共<em class="shop-title-red">{{shopTotal}}</em>件相关商品</span>
      </div>
      <div class="fix">
        <div class="shop-tab" @click="selectTab(1)" :class="shopBean.tab == 1 ? 'shop-tab-active' : ''">
          <i class="shop-icon shop-icon-gift"></i>
          虚宝兑换
        </div>
        <div class="shop-tab" @click="selectTab(2)" :class="shopBean.tab == 2 ? 'shop-tab-active' : ''">
          <i class="shop-icon shop-icon-matter"></i>
          论坛商品
        </div>
      </div>
      <div class="shop-select-body">
        <div class="shop-price-type">
          <span>积分价格 ：</span>
          <a class="shop-select-a" :class="shopBean.price === item.id ? 'shop-select-a-active' : '' "
            v-for="(item,index) in priceList" :key="index" @click="selectPrice(item.id)">
            {{item.name}}
          </a>
        </div>
        <div class="shop-letter-type">
          <span>字&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;母 ：</span>
          <a class="shop-select-a" :class="shopBean.letter === item.id ? 'shop-select-a-active' : ''"
            v-for="(item,index) in letterList" :key="index" @click="selectLetter(item.id)">
            {{item.name}}
          </a>
        </div>
        <div class="shop-sort-type">
          <span>商品排序 ：</span>
          <a class="shop-select-a" v-for="(item,index) in rankList" :key="index" @click="selectRank(item.id)"
            :class="shopBean.rank === item.id ? 'shop-select-a-active' : '' ">
            {{item.name}}
          </a>
        </div>
      </div>
      <div class="shop-content-body">
        <ul class="fix">
          <li class="shop-content-li" :class="index%4 == 3 ? 'mr-0':''" v-for="(item,index) in shopList" :key="index">
            <div class="shop-content-header">
              <div class="shop-content-avatar" @click="enterShopDetails(item.shop_id)" v-show="item.shop_type == 1">
                <img class="shop-content-gift-img" :src="baseImageAddress+'type=small&game_tag='+item.game_tag">
                <i class="shop-content-subscript"></i>
              </div>
              <img class="shop-content-matter-img" :src="baseAddress+item.shop_preview" v-show="item.shop_type == 2">
            </div>
            <div class="shop-content-data">
              <span class="title">{{item.shop_name}}</span>
              <p class="price">¥<i>{{item.shop_consume_count}}</i>积分</p>
              <p class="used">已兑换<i>{{item.shop_convert}}</i>件</p>
              <div class="opt">
                <div class="g-count-number">
                  <div class="g-number">
                    <input class="g-number-input" value="1" v-model="item.shop_count">
                    <a class="number-btn number-btn-plus" @click="handleCount(1,index)">+</a>
                    <a class="number-btn number-btn-minus" @click="handleCount(2,index)">-</a>
                  </div>
                </div>
                <div class="exchange" @click="enterShopDetails(item.shop_id)">购买</div>
              </div>
            </div>
          </li>
        </ul>
        <CommonPage v-if="showPageState" :current.sync='shopBean.page' :page-size="16" :total="shopTotal" 
          show-total @on-change="selectPage" next-text="下一页" prev-text="上一页" class="center-game-page shop-page"/> 
      </div>
    </div>

    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
      @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
      @changeLoginState="changeLoginState"></SuspendMember>
  </div>
</template>
<script>
  import Footer from "../../components/common/Footer";
  import Header from '../../components/common/Header';
  import SuspendSide from '../../components/SuspendSide';
  import SuspendMember from '../../components/SuspendMember';
  import CommonPage from '../../components/CommonPage';
export default { 
  components: {
    Footer, Header, SuspendSide,SuspendMember, CommonPage
  },
  metaInfo(){
    return {
      title:"商品中心_"+this.$store.state.home.title,
      meta:[
        { name:'keywords', content:this.$store.state.home.keywords},
        { name:'description',content:this.$store.state.home.description}
      ]
    }
  },
  computed: {
    shopList:{
      get(){
        return this.$store.state.shopMore.shopList;
      },
      set(value){
        this.$store.state.shopMore.shopList = value;
      }
    },
    //商品总数
    shopTotal:{
      get(){
        return this.$store.state.shopMore.shopTotal;
      },
      set(value){
        this.$store.state.shopMore.shopTotal = value;
      }
    },
    showPageState:{
      get(){
        return this.$store.state.shopMore.showPageState;
      },
      set(value){
        this.$store.state.shopMore.showPageState = value;
      }
    },
    baseAddress(){
      return this.$store.state.constant.baseAddress;
    },
    baseImageAddress(){
      return this.$store.state.constant.baseImageAddress;
    }
  },
  asyncData({store,route}){
    return store.dispatch('initAllShop',route.query.type)
  },
  data() {
    return {
      loginState:false,
      isRequestState:false,
      suspendState:false,
      suspendType:0,
      shopBean:{
        tab:1, //商品tab地址
        price:0, //价格地址
        rank:0, //排序地址
        letter:0, //字母排序
        page:1,
        row:16
      },
      priceList:[
        {id:0, name:"全部"},
        {id:1, name:"1~500"},
        {id:2, name:"501~2000"},
        {id:3, name:"2001~5000"},
        {id:4, name:"5000~10000"},
        {id:5, name:"10000起"},
      ],
      tabTitle:"虚拟", //商品tab名称
      rankList:[
        {id:0,name:"默认排序"},
        {id:1,name:"商品价格"},
        {id:2,name:"最新商品"},
        {id:3,name:"商品热度"}
      ],
      letterList:[
        { id: 0, name:'全部'},
        { id: 1, name: "ABCD" },
        { id: 2, name: "EFGH" },
        { id: 3, name: "IJKL" },
        { id: 4, name: "MNOP" },
        { id: 5, name: "QRST" },
        { id: 6, name: "UVWX"},
        { id: 7, name: "YZ"}
      ],
    };
  },
  mounted(){
    this.shopBean.tab = this.$route.query.type;
    if(this.shopBean.tab == undefined){
      this.shopBean.tab = 1;
    }
    if (window.sessionStorage.getItem("token") !== null) {
      this.loginState=true;
    }
  },
  methods: {
    handleCount(type,index){
      if(type == 1){
        //增加
        this.shopList[index].shop_count += 1;
        if(this.shopList[index].shop_count > this.shopList[index].shop_remain){
          this.shopList[index].shop_count = this.shopList[index].shop_remain;
        }
      }else{
        //减少
        this.shopList[index].shop_count -= 1;
        if(this.shopList[index].shop_count < 1){
          this.shopList[index].shop_count = 1;
        }
      }
    },
    changeSuspendState(value){
      this.suspendState = value;
    },
    changeSuspendType(value){
      this.suspendType = value;
    },
    changeLoginState(value){
      this.loginState = value;
    },
    selectTab(value){
      if(this.shopBean.tab == value){
        return;
      }
      if(value == 2){
        this.tabTitle = "实物";
      }else{
        this.tabTitle = "虚拟";
      }
      this.isRequestState = false;
      this.shopBean.tab = value;
      this.shopBean.page = 1;
      this.queryAllShop();
    },
    selectPage(value){
      this.shopBean.page = value;
      this.isRequestState = false;
      this.queryAllShop();
    },
    queryAllShop(){
      if(!this.isRequestState){
        this.$http.get(`query_all_shop`,{
          params:this.shopBean
        }).then(res=>{
          if (res.data.code ==2000) {
            this.shopList = res.data.data;
            this.shopTotal = res.data.total;
            if(this.shopTotal > 16){
              this.showPageState = true;
            }else{
              this.showPageState = false;
            }
            this.isRequestState = true;
          }else{
            this.shopTotal=0;
            this.shopList=[];
          }
        });
      } 
    },
    
    selectPrice(value){
      this.shopBean.price = value;
      this.shopBean.page=1;
      this.isRequestState = false;
      this.queryAllShop();
    },
    selectRank(value){
      this.shopBean.rank =value;
      this.shopBean.page=1;
      this.isRequestState = false;
      this.queryAllShop();                                           
    },
    selectLetter(value){
      this.shopBean.letter = value;
      this.shopBean.page = 1;
      this.isRequestState = false;
      this.queryAllShop();
    },
    enterShopDetails(value) {
      //先判断是否登陆
      if(!this.loginState){
        this.changeSuspendState(true);
        this.changeSuspendType(0);
        return;
      }
      this.$router.push({name:'shopDetails',query:{sid:value}});  
    },
  },
};
</script>
<style src="@/assets/css/shop/shop_more.css" scoped></style>
<style >
  .shop-page .ivu-page-next{
    background:#fff;
  }

  .shop-page .ivu-page-prev{
    background: #fff;
  }
</style>
